import PatchController from '../PatchController';

export default class ProgramsFurtherController extends PatchController {
	public handle() {
		this.redirect(this.routes.program.further.href);
	}
}
